/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Serializer for the Language model
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface Language { 
    readonly id: number;
    name: string;
    code: string;
}
export const Language_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Language_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(1023),];

export const Language_code_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(2),];


